export default "__VITE_ASSET__CAw2in8o__"